// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import '@/components'

import '@/assets/css/common/icon-sys.css'
import router from './router'
import store from './store'
import axios from './http'
import api from './api'
import common from './common/common.js'

Vue.prototype.$axios=axios
Vue.prototype.$api=api
Vue.prototype.$common=common

Vue.use(ElementUi)
Vue.config.productionTip = false
window.vm=new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  data:{
  }
})



// WEBPACK FOOTER //
// ./src/main.js